import React from 'react';
import { Tooltip } from 'antd';
import { twJoin } from '@shared/utils/twMerge';

type TruncatedTextProps = {
  text?: string | null;
  tooltipColor?: string;
  tooltipClassName?: string;
  truncate?: boolean;
  tooltip: boolean;
  className?: string;
};

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  tooltipColor = 'white',
  tooltipClassName = 'text-black',
  className,
  truncate,
  tooltip = false,
}) => {
  return (
    <>
      {tooltip ? (
        <Tooltip
          color={tooltipColor}
          title={<div className={tooltipClassName}>{text}</div>}
        >
          <span className={twJoin(className, truncate && 'truncate')}>{text}</span>
        </Tooltip>
      ) : (
        <p className={className}>{text}</p>
      )}
    </>
  );
};
